import Settings from './component';

export default Settings;
